import store from "@/store";
import { setStateMutation } from "@/store/plugins/perssist";
import { isTokenExpired } from "@/modules/auth/jwt-helpers";

export default {
  // Chamada do plugin para o IndexDb
  setState(state, payload) {
    setStateMutation(state, payload);

    if (state.loggedIn && isTokenExpired(state.token)) {
      store.dispatch("auth/refreshToken");
    }
  },
  setSessionUser(state, payload) {
    const { token, refreshToken, user } = payload;

    state.loggedIn = true;
    state.user = user;
    state.token = token;
    state.refreshToken = refreshToken;
  },
  setToken(state, payload) {
    const { token } = payload;

    state.token = token;
  },
  setRefreshToken(state, payload) {
    const { refreshToken } = payload;

    state.refreshToken = refreshToken;
  },
  clearSession(state) {
    state.loggedIn = false;
    state.user = null;
    state.token = null;
    state.refreshToken = null;
  }
};
